<template>
  <div class="section mb-3">
    <h4 class="section-title">
      <font-awesome-icon :icon="['far', 'calendar']" /> Datos Básicos
    </h4>
    <div class="row mb-2">
      <div class="col-md-6">
        <label for="fecha_creacion" class="form-label">Fecha de la Tarea</label>
        <input type="datetime-local" class="form-control form-control-sm" id="fecha_creacion"
          v-model="localDatosBasicos.fecha_creacion" @input="enviarDatos" required />
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
        <label class="form-label">Personal que Trabajo en esta tarea</label>
        <PersonalSelector @selected-personal="actualizarPersonalSeleccionado" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.section {
  border: 1px solid var(--border-color, #e3e3e3);
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 20px;
  background-color: var(--background-color, #f9f9f9);
  transition: background-color 0.3s ease;
}

.section:hover {
  background-color: var(--hover-background-color, #f1f1f1);
}

.section-title {
  margin-bottom: 15px;
  font-size: 1.2rem;
  color: var(--app-primary, #333);
  font-weight: bold;
}

.form-label {
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.form-control-sm {
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  border: 1px solid var(--input-border-color, #ccc);
  border-radius: 5px;
  transition: border-color 0.3s ease;
}

.form-control-sm:focus {
  border-color: var(--focus-border-color, #007bff);
  outline: none;
}
</style>

<script>
import PersonalSelector from '../../Personal/PersonalSelector.vue'; // Asegúrate de tener el componente PersonalSelector

export default {
  components: {
    PersonalSelector,
  },
  data() {
    return {
      localDatosBasicos: {
        fecha_creacion: '',
        personalAsignado: [], // Almacena la lista de personal asignado
      },
    };
  },
  created() {
    // Inicializar los datos básicos con la fecha actual
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60000);
    this.localDatosBasicos.fecha_creacion = localDate.toISOString().slice(0, 16);
    this.enviarDatos();
  },
  methods: {
    enviarDatos() {
      // Enviar los datos al componente padre
      this.$emit('actualizar-datos-basicos', this.localDatosBasicos);
    },
    actualizarPersonalSeleccionado(personalSeleccionado) {
      // Actualizar el personal asignado
      this.localDatosBasicos.personalAsignado = personalSeleccionado;
      this.enviarDatos(); // Enviar los datos actualizados
    },
  },
};
</script>
